import React from 'react';
import { Control, Controller } from 'react-hook-form';
import kioskLogo from '@/components/atoms/Icon/svg/kiosk.svg';
import webLogo from '@/components/atoms/Icon/svg/web.svg';
import posLogo from '@/components/atoms/Icon/svg/pos.svg';
import trayScanLogo from '@/components/atoms/Icon/svg/scaner.svg';
import vendingMachineLogo from '@/components/atoms/Icon/svg/vendingMachine-black.svg';
import {
    WebhookChannels,
    WebhookEventTypes,
    WebhookConfig,
    WebhookHeader,
} from '../../../../pages/Config/Webhooks/types';

export const availableWebhookChannels: WebhookChannels[] = [
    {
        channelId: 1,
        name: 'kiosk',
        logo: kioskLogo,
    },
    {
        channelId: 2,
        name: 'web',
        logo: webLogo,
    },
    {
        channelId: 5,
        name: 'pos',
        logo: posLogo,
    },
    {
        channelId: 8,
        name: 'vendingMachine',
        logo: vendingMachineLogo,
    },
    {
        channelId: 12,
        name: 'trayScan',
        logo: trayScanLogo,
    },
];

export type EventTypeOption = {
    value: WebhookEventTypes;
    label: string;
};

export const availableEventTypes: EventTypeOption[] = [
    {
        value: WebhookEventTypes.customerFirstNameUpdate,
        label: 'customer.firstName.updated',
    },
    {
        value: WebhookEventTypes.customerLastNameUpdate,
        label: 'customer.lastName.updated',
    },
    {
        value: WebhookEventTypes.customerEmailUpdate,
        label: 'customer.email.updated',
    },
    {
        value: WebhookEventTypes.customerBadgeAdded,
        label: 'customer.badge.added',
    },
    {
        value: WebhookEventTypes.customerBadgeNumberUpdate,
        label: 'customer.badge.number_updated',
    },
    {
        value: WebhookEventTypes.customerBadgeDeleted,
        label: 'customer.badge.deleted',
    },
    {
        value: WebhookEventTypes.customerBadgeSetDefault,
        label: 'customer.badge.set_default',
    },
    {
        value: WebhookEventTypes.customerBadgeBlocked,
        label: 'customer.badge.blocked',
    },
    {
        value: WebhookEventTypes.customerBadgeTypeUpdate,
        label: 'customer.badge.type_updated',
    },
    {
        value: WebhookEventTypes.transactionsNotification,
        label: 'transactions.notification',
    },
];

export interface BrandWebhookConfigurationPanelProps {
    webhook?: WebhookConfig;
    setValid: (state: boolean) => void;
    setDirty?: (state: boolean) => void;
}

export type BrandWebhookConfigurationPanelViewModel = {
    control: Control<WebhookConfig>;
    headers: (WebhookHeader & { id: string })[];
    isEditWebhook: boolean;
    webhook?: WebhookConfig;
    toggleChannel: (value: number[], channelId: number, onChange: (channels: number[]) => void) => void;
    copyToClipboard: (event: React.MouseEvent<HTMLSpanElement>, text: string) => void;
    append: (value: WebhookHeader) => void;
    remove: (index: number) => void;
    Controller: typeof Controller;
};
